import ContentEditable from "react-contenteditable";
import { IStatus } from "../IWebsiteDataV3";
import sanitizeHtml from "sanitize-html";
import { statusLabels } from "./StatusPopoverPicker";

export const StatusMessage: React.FC<{ status: IStatus; message: string; onChange: (message: string) => void; }> = ({ status, message, onChange }) => {
    const onContentChange = (evt: any) => {
        const sanitizeConf = {
            allowedTags: ["b", "i", "a"],
            allowedAttributes: { a: ["href"] }
        };

        const content = sanitizeHtml(evt.currentTarget.innerHTML, sanitizeConf);
        onChange(content);
	};
    return (
        <ContentEditable
            style={{ display: 'inline'}}
            onChange={(e) => onContentChange(e)}
            html={message || statusLabels[status] }
        />
    )
}
